import { WidgetSettingsBuilder } from './widget-settings.builder';
import { WidgetMigrationStatus } from './widget.i';
var WidgetBuilder = /** @class */ (function () {
    function WidgetBuilder() {
        this.item = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            name: 'Bob widget',
            description: '',
            migrationStatus: WidgetMigrationStatus.NEW,
            settings: new WidgetSettingsBuilder().build()
        };
    }
    WidgetBuilder.prototype.withId = function (id) {
        this.item.id = id;
        return this;
    };
    WidgetBuilder.prototype.withName = function (name) {
        this.item.name = name;
        return this;
    };
    WidgetBuilder.prototype.withDescription = function (desc) {
        this.item.description = desc;
        return this;
    };
    WidgetBuilder.prototype.withSettings = function (settings) {
        this.item.settings = settings;
        return this;
    };
    WidgetBuilder.prototype.withNewSettings = function (newSettings) {
        this.item.newSettings = newSettings;
        return this;
    };
    WidgetBuilder.prototype.build = function () {
        return this.item;
    };
    return WidgetBuilder;
}());
export { WidgetBuilder };
//# sourceMappingURL=widget.builder.js.map